/* Cart quantity cap. See migration/transform/product_max_quantity.py.
 *
 * The theme's counter honors the input's max attribute, and snippets/cart-item.liquid
 * writes that attribute from custom.max_quantity. That stops the plus button. It does
 * not stop Shopify merging a second Add to cart of the same course into one line of two,
 * and it does not stop a POST to /cart/add.js. This corrects the first case as soon as
 * the cart renders; only a Cart and Checkout Validation Function can refuse the second,
 * and that is separate work.
 *
 * Runs on load and whenever the cart drawer re-renders. Idempotent. */
(function () {
  var busy = false;
  function clamp() {
    if (busy) return;
    var over = Array.prototype.filter.call(
      document.querySelectorAll('.js-counter-quantity[max]'),
      function (el) { return parseInt(el.value, 10) > parseInt(el.max, 10); }
    );
    if (!over.length) return;
    busy = true;
    var el = over[0];
    var key = el.getAttribute('data-quantity-variant-id');
    fetch((window.routes && window.routes.cart_change_url) || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: parseInt(el.max, 10) })
    }).then(function () { window.location.reload(); })
      .catch(function () { busy = false; });
  }
  /* A one-per-order product that is already in the cart: the terms snippet marked
   * the page (snippets/abz-product-terms.liquid); the button is disabled for real
   * and says so. CSS grays it whether or not this ran. */
  function markInCart() {
    var mark = document.querySelector('.abz-terms--in-cart');
    if (!mark) return;
    /* every add button on the page: the form's, and the theme's sticky buy bar */
    Array.prototype.forEach.call(document.querySelectorAll('.js-add-to-cart'), function (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('abz-in-cart');
      var label = btn.querySelector('span') || btn;
      label.textContent = mark.getAttribute('data-abz-in-cart-label') || 'Already in cart';
    });
  }
  document.addEventListener('DOMContentLoaded', function () { clamp(); markInCart(); });
  var drawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(function () { clamp(); }).observe(drawer, { childList: true, subtree: true });
  }
})();
